module.exports = __webpack_public_path__ + "img/s3Model5.19fa7f65.webp";